import { parseNullableValue } from '@clearverify/utils';

import { PermissiblePurposeReference } from 'src/api';

export const getPermissiblePurposeReferenceOption = (
  permissiblePurposeReference: Pick<PermissiblePurposeReference, 'id' | 'label'>,
) => {
  return {
    value: String(permissiblePurposeReference.id),
    label: parseNullableValue(permissiblePurposeReference.label),
  };
};
